import { render, staticRenderFns } from "./codification-default.vue?vue&type=template&id=29c6e0cf"
import script from "./codification-default.vue?vue&type=script&lang=js"
export * from "./codification-default.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports